export const SET_BACKEND = 'SET_BACKEND';
export const SET_THERMAL_STREAM_SETTINGS = 'SET_THERMAL_STREAM_SETTINGS';
export const SET_RGB_STREAM_SETTINGS = 'SET_RGB_STREAM_SETTINGS';
export const SET_RGB_FACE_DETECTION_SETTINGS = 'SET_RGB_FACE_DETECTION_SETTINGS';
export const SET_THERMAL_FACE_DETECTION_SETTINGS = 'SET_THERMAL_FACE_DETECTION_SETTINGS';
export const SET_MASK_DETECTION_SETTINGS = 'SET_MASK_DETECTION_SETTINGS';
export const CLEAR_THERMAL_SOLUTION_BOX = 'CLEAR_THERMAL_SOLUTION_BOX';
export const START_THERMAL_PROCESS = 'START_THERMAL_PROCESS';

export const setBackend = (backend) => {
  return {
    type: SET_BACKEND,
    backend,
  };
};

export const setThermalStreamSettings = (field, data) => {
  return {
    type: SET_THERMAL_STREAM_SETTINGS,
    field,
    data,
  };
};

export const setRGBStreamSettings = (field, data) => {
  return {
    type: SET_RGB_STREAM_SETTINGS,
    field,
    data,
  };
};

export const setMaskDetectionSettings = (field, data) => {
  return {
    type: SET_MASK_DETECTION_SETTINGS,
    field,
    data,
  };
};

export const setRGBFaceDetectionSettings = (field, data) => {
  return {
    type: SET_RGB_FACE_DETECTION_SETTINGS,
    field,
    data,
  };
};

export const setThermalFaceDetectionSettings = (field, data) => {
  return {
    type: SET_THERMAL_FACE_DETECTION_SETTINGS,
    field,
    data,
  };
};

export const clearThermalSolutionBox = (value) => {
  return {
    type: CLEAR_THERMAL_SOLUTION_BOX,
    value,
  };
};

export const startThermalProcess = (value) => {
  return {
    type: START_THERMAL_PROCESS,
    value,
  };
};
